import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { VFileUpload } from "vuetify/labs/VFileUpload";

const vuetify = createVuetify({
    components: {
        ...components,
        VFileUpload,
    },
    directives,
});

const app = createApp(App);
app.use(createPinia());
app.use(vuetify);
app.mount("#app");
